import { render, staticRenderFns } from "./BatchSettlement.vue?vue&type=template&id=7e2c07b6&scoped=true"
import script from "./BatchSettlement.vue?vue&type=script&lang=ts"
export * from "./BatchSettlement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c07b6",
  null
  
)

export default component.exports